import type { AnimationCompositionV1, HumanoidAnimationAssetV1, ItemPoseType } from "@hyperlight/shared";
import wave from "../../public/anim/actions/wave-left.hlanim.json";

export const RIFLE_COMPOSITION: AnimationCompositionV1 = {
  version: 1, id: "rifle-gestures", movement: "rifle", hold: "equipped-item", aim: "rifle-offset",
  actions: [{
    id: "wave", source: wave as unknown as HumanoidAnimationAssetV1, mask: "left-arm", blend: "override",
    fadeIn: 0.3, fadeOut: 0.35, priority: 10,
    interrupts: ["aim", "reload", "airborne", "equipment", "action", "interaction"],
  }],
};

export function compositionForItem(item: ItemPoseType): AnimationCompositionV1 {
  return { ...RIFLE_COMPOSITION, id: `${item}-gestures`, movement: item, aim: "item-offset" };
}
